import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import MainInput from "./../../../component/atoms/input/mainInput";
import BasicBtn from "./../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import { route } from "../../../router/route";
import scrollToTop from "../../../util/scrollToTop";
import BoardApi from "../../../api/board.api";
import { errorHandler } from "../../../util/errorHandler";

const SecretQnaEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getQnaInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 멤버십 QnA 상세 정보 ---------- //
  const [qnaInfo, setQnaInfo] = useState();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const getQnaInfo = async () => {
    try {
      const response = (await BoardApi.getByIdBoard(id)).data.data.content;

      setQnaInfo(response);
      setTitle(response?.title || "");
      setContent(response?.content || "");
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 멤버십 QnA 수정 ---------- //
  const updateQna = async () => {
    try {
      await BoardApi.updateBoard(id, {
        title: title,
        content: content,
      });

      navigate(`${route.secret_qna_detail}/${id}`, { replace: true });
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 QnA 수정</TableTitle>
          <div
            style={{
              width: "100%",
              marginBottom: 20,
            }}
          >
            <MainInput
              type="text"
              placeholder="제목을 입력해주세요"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={{
                width: "100%",
                height: 48,
                padding: "0 16px",
              }}
            />
          </div>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={600}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn onClick={updateQna}>업로드하기</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default SecretQnaEdit;
